import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '~/libs/api';
import { thunkErrorHandler } from '~/store/utils.ts';
import {
  TApplicationsContactInformationForm,
  TApplicationsIdRemoteBankingContacts,
} from '~/store/remote-banking-contacts/types.ts';

export const contactInformationFormForm = createAsyncThunk<
  TApplicationsIdRemoteBankingContacts,
  TApplicationsContactInformationForm
>('remoteBankingContacts/contactInformationForm', async (data, { rejectWithValue }) => {
  try {
    const response = await api.post(`/remote-banking-contacts/applications`, data);
    return response.data;
  } catch (error) {
    return thunkErrorHandler(error, rejectWithValue);
  }
});
